"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IntegrationService = function () {
    function IntegrationService($http, appConfig) {
        "ngInject";

        (0, _classCallCheck3.default)(this, IntegrationService);
        this.$http = $http;
        this.appConfig = appConfig;
    }

    (0, _createClass3.default)(IntegrationService, [{
        key: "sendForSignature",
        value: function sendForSignature(entityId, enquiryId, additionalRecipients, code, orderFormVersion) {
            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/integration/sendforsignature/", { entityId: entityId, enquiryId: enquiryId, additionalRecipients: additionalRecipients, code: code, orderFormVersion: orderFormVersion });
        }
    }, {
        key: "sendTradeFormForSignature",
        value: function sendTradeFormForSignature(entityId, enquiryId, additionalRecipients, code) {
            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/integration/sendtradeformforsignature/", { entityId: entityId, enquiryId: enquiryId, additionalRecipients: additionalRecipients, code: code });
        }
    }, {
        key: "getMazdaServiceHistory",
        value: function getMazdaServiceHistory(mazdaToken, orgName, chassisNo) {
            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/integration/GetMazdaServiceHistory/", { mazdaToken: mazdaToken, orgName: orgName, chassisNo: chassisNo });
        }
    }, {
        key: "getMazdaRecallHistory",
        value: function getMazdaRecallHistory(mazdaToken, orgName, chassisNo) {
            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/integration/GetMazdaRecallHistory/", { mazdaToken: mazdaToken, orgName: orgName, chassisNo: chassisNo });
        }
    }]);
    return IntegrationService;
}();

exports.default = IntegrationService;


// WEBPACK FOOTER //
// ./client/app/common/services/integration.service.js